/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Left_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Center left" |
*
* @param {Position_Center_Left_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_left_aria_label = /** @type {((inputs?: Position_Center_Left_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Left_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au centre a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitte links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр слева")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左中")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央左")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro esquerdo")
	return /** @type {LocalizedString} */ ("Center left")
});